"use strict";

document.addEventListener('DOMContentLoaded', function () {

    // Fallback for the prototype (DE)
    const splideI18nDefault = {
        prev: 'Vorheriger Slide',
        next: 'Nächster Slide',
        first: 'Erster Slide',
        last: 'Letzter Slide',
        slideX: 'Gehe zu Slide %s',
        pageX: 'Gehe zu Seite %s',
        play: 'Autoplay starten',
        pause: 'Autoplay pausieren',
        carousel: 'Slider',
        slide: 'Slide',
        select: 'Wähle einen Slide zum Anzeigen',
    };

    // Logic for initialization (Merging of defaults and MODX overrides)
    const i18nConfig = Object.assign({}, splideI18nDefault, window.splideL10n || {});



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('js-hero-slider');

    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            const splide = new Splide(heroSlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            });

            const animateHeroCaption = () => {
                heroSlider[i].querySelectorAll('.heroSlider__captionInner').forEach(el => {
                    el.classList.remove('is-animated');
                });
                const activeCaption = heroSlider[i].querySelector('.is-active .heroSlider__captionInner');
                if (activeCaption) {
                    requestAnimationFrame(() => activeCaption.classList.add('is-animated'));
                }
            };

            splide.on('mounted', () => {
                if (splide.length < 2) {
                    heroSlider[i].querySelector('.splide__pagination')?.remove();
                    heroSlider[i].querySelector('.splide__arrows')?.remove();
                }
                animateHeroCaption();
            });
            splide.on('moved', animateHeroCaption);
            splide.mount();
        }
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *

    // const textSlider = document.getElementsByClassName('js-text-slider');

    // if (textSlider !== null) {
    //     for (let i = 0; i < textSlider.length; i++) {
    //         new Splide(textSlider[i], {
    //             type: 'slide',
    //             rewind: true,
    //             arrows: true,
    //             pagination: true,
    //             lazyLoad: 'nearby',
    //             perPage: 1,
    //             gap: '3rem',
    //             i18n: i18nConfig,
    //             breakpoints: {
    //                 768: {
    //                     perPage: 1,
    //                 }
    //             }
    //         }).mount();
    //     }
    // }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide introSlider
    // *
    // *

    const introSlider = document.getElementsByClassName('js-intro-slider');

    if (introSlider !== null) {
        for (let i = 0; i < introSlider.length; i++) {
            new Splide(introSlider[i], {
                type: 'loop',
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
                i18n: i18nConfig,
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide accordionImageSlider
    // *
    // *

    const accordionImageSlider = document.getElementsByClassName('js-accordion-image-slider');

    if (accordionImageSlider !== null) {
        for (let i = 0; i < accordionImageSlider.length; i++) {
            new Splide(accordionImageSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
                i18n: i18nConfig,
            }).mount();
        }
    }



    // * splide teamintroSlider
    // *
    // *

    const teamintroSlider = document.getElementsByClassName('js-teamintro-slider');

    if (teamintroSlider !== null) {
        for (let i = 0; i < teamintroSlider.length; i++) {
            new Splide(teamintroSlider[i], {
                type: 'fade',
                rewind: true,
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig,
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide teamSlider
    // *
    // *

    const teamSlider = document.getElementsByClassName('js-teamslider');

    if (teamSlider !== null) {
        for (let i = 0; i < teamSlider.length; i++) {
            let container = teamSlider[i];
            let splide = new Splide(container, {
                type: 'loop',
                arrows: true,
                pagination: true,
                perPage: 1,
                gap: '20px',
                rewind: true,
                i18n: i18nConfig
            });

            splide.mount();
        }
    }

    

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide teaserSlider
    // *
    // *

    const teaserSlider = document.getElementsByClassName('js-teaser-slider');

    if (teaserSlider !== null) {
        for (let i = 0; i < teaserSlider.length; i++) {
            const splide = new Splide(teaserSlider[i], {
                type: 'loop',
                perPage: 3,
                gap: '20px',
                arrows: true,
                pagination: false,
                i18n: i18nConfig,
                breakpoints: {
                    1240: {
                        perPage: 2,
                    },
                    767: {
                        perPage: 1,
                    }
                }
            });

            const updateArrows = () => {
                const arrowsEl = teaserSlider[i].querySelector('.splide__arrows');
                if (arrowsEl) {
                    arrowsEl.style.display = splide.length <= splide.options.perPage ? 'none' : '';
                }
            };

            splide.on('mounted updated', updateArrows);
            splide.mount();
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    const anchors = document.querySelectorAll(".js-scrollTo");

    for (const anchor of anchors) {
        anchor.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();

        let href = this.getAttribute("href").split("#");
        let newAnchor = "#my" + href[1]
        let offsetTop = document.querySelector(newAnchor).offsetTop;

        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash link jump to content
    // *
    // *

    window.addEventListener('load', function () {
        let getHash = window.location.hash;
        let elementExists = document.getElementById("my" + getHash.slice(1));

        if (getHash !== null && elementExists !== null) {
            let name = "#my" + getHash.slice(1);
            let offsetTop = document.querySelector(name).offsetTop;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }

    }, false);



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *

    const scrolltotop = document.querySelector(".js-scrolltop");

    if (scrolltotop !== null) {
        // show and hide scrollToTop btn on scroll
        document.addEventListener('scroll', function (e) {
            if (window.scrollY > 300) {
                scrolltotop.classList.add("show");
            } else {
                scrolltotop.classList.remove("show");
            }
        });

        // onclick scroll to top
        scrolltotop.onclick = function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }


    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * anchor nav scrollTo
    // *
    // *

    // get browser width
    let browserWidth = window.innerWidth;
    let anchorBox = document.querySelector('.js-anchor-nav');
    let anchorBoxSticky = document.querySelector('.js-anchor-sticky');

    // check if anchor modul is set to sticky
    if (anchorBoxSticky !== null) {
        window.addEventListener('scroll', function (e) {
            // get pos from anchorbox
            let pos = Math.round(anchorBox.getBoundingClientRect().y);

            if (pos <= 0) {
                anchorBox.classList.add("stick");
            } else {
                anchorBox.classList.remove("stick");
            }
        });
    }

    // check if anchor modul is set
    if (anchorBox !== null) {
        // needed for sticky anchor to calculate offsetTop
        anchorBoxHeight = anchorBox.offsetHeight;

        if (browserWidth > 1280) {
            anchorBoxHeight = anchorBoxHeight;
        } else {
            anchorBoxHeight = 0;
        }

        const anchors = document.querySelectorAll(".js-scrollTo");

        for (const anchor of anchors) {
            anchor.addEventListener("click", clickHandler);
        }

        function clickHandler(e) {
            e.preventDefault();

            let href = this.getAttribute("href").split("#");
            let newAnchor = "#my" + href[1]
            let offsetTop = document.querySelector(newAnchor).offsetTop - anchorBoxHeight;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * pagejump nav scrollTo
    // *
    // *

    let pagejumpBox = document.querySelector('.js-pagejump-nav');
    let pagejumpBoxSticky = document.querySelector('.js-pagejump-sticky');

    // check if pagejump is set to sticky
    if (pagejumpBoxSticky !== null) {
        window.addEventListener('scroll', function () {
            let pos = Math.round(pagejumpBox.getBoundingClientRect().y);

            if (pos <= 0) {
                pagejumpBox.classList.add("stick");
            } else {
                pagejumpBox.classList.remove("stick");
            }
        });
    }

    // pagejump horizontal scroll via mouse wheel
    if (pagejumpBox !== null) {
        const pagejumpInner = pagejumpBox.querySelector(".pagejump__inner");

        pagejumpInner.addEventListener("wheel", function (e) {
            if (pagejumpInner.scrollWidth <= pagejumpInner.clientWidth) return;

            e.preventDefault();
            pagejumpInner.scrollLeft += e.deltaY;
        });
    }

    // check if pagejump is set
    if (pagejumpBox !== null) {
        const pagejumpLinks = pagejumpBox.querySelectorAll(".js-scrollTo");

        for (const link of pagejumpLinks) {
            link.addEventListener("click", function (e) {
                e.preventDefault();

                let href = this.getAttribute("href").split("#");
                let target = document.querySelector("#" + href[1]);

                if (target) {
                    let offsetTop = target.offsetTop - pagejumpBox.getBoundingClientRect().bottom - 20;
                    scroll({ top: offsetTop, behavior: "smooth" });
                }
            });
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * pagejump active state on scroll
    // *
    // *

    if (pagejumpBox !== null) {
        const pagejumpItems = pagejumpBox.querySelectorAll('.pagejump__item');
        const sectionMap = [];

        pagejumpItems.forEach(item => {
            const link = item.querySelector('.js-scrollTo');
            if (!link) return;
            const target = document.querySelector(link.getAttribute('href'));
            if (target) sectionMap.push({ item, target });
        });

        if (sectionMap.length > 0) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    const match = sectionMap.find(s => s.target === entry.target);
                    if (!match) return;
                    pagejumpItems.forEach(i => i.classList.remove('pagejump__item--active'));
                    match.item.classList.add('pagejump__item--active');
                });
            }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

            sectionMap.forEach(({ target }) => observer.observe(target));
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpenButtons = document.querySelectorAll(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");

    /* hide sidebar buttons if no modal exists on this page */
    if (!modalWindow) {
        modalOpenButtons.forEach(btn => {
            const parentItem = btn.closest('.sidebar__item');
            if (parentItem) {
                parentItem.classList.add('is-hidden');
            }
        });
    }

    /* function to handle modal closing */
    const closeModal = () => {
        if (modalWindow && typeof modalWindow.close === "function") {
            modalWindow.close();
        } else if (modalWindow) {
            modalWindow.style.display = "none";
        }
        document.body.classList.remove('freeze');
        
        // Show all hidden sidebar items again
        document.querySelectorAll('.sidebar__item.is-hidden').forEach(item => {
            item.classList.remove('is-hidden');
        });
    };

    /* onclick show modal window */
    if (modalOpenButtons.length > 0 && modalWindow) {
        modalOpenButtons.forEach(btn => {
            btn.onclick = function (e) {
                e.preventDefault();
                if (typeof modalWindow.showModal === "function") {
                    modalWindow.showModal();
                } else {
                    modalWindow.style.display = "block";
                }
                modalWindow.focus();
                document.body.classList.add('freeze');

                // Hide the parent sidebar item if it exists
                const parentItem = btn.closest('.sidebar__item');
                if (parentItem) {
                    parentItem.classList.add('is-hidden');
                }
            }
        });
    }

    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = closeModal;
    }

    /* clicks anywhere outside close modal window */
    window.onclick = function (event) {
        if (event.target == modalWindow) {
            closeModal();
        }
    }

    /* native close event (e.g. via ESC key) */
    if (modalWindow !== null) {
        modalWindow.addEventListener('close', function() {
            document.body.classList.remove('freeze');
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion - only one item open at a time
    // *
    // *

    const accordionTitles = document.querySelectorAll(".js-accordion-title");

    if (accordionTitles.length > 0) {
        accordionTitles.forEach(title => {
            title.addEventListener('click', function (e) {
                const isOpen = this.classList.contains("open");
                const accordion = this.closest('.accordion');

                // close all items in the same accordion
                if (accordion) {
                    accordion.querySelectorAll('.js-accordion-title.open').forEach(openTitle => {
                        openTitle.classList.remove("open");
                        openTitle.setAttribute('aria-expanded', 'false');
                        const openItem = openTitle.closest('.accordion__item');
                        if (openItem) {
                            openItem.querySelector('.accordion__content')?.classList.remove("open");
                        }
                    });
                }

                // open clicked item if it was closed
                if (!isOpen) {
                    this.classList.add("open");
                    this.setAttribute('aria-expanded', 'true');
                    const accordionItem = this.closest('.accordion__item');
                    if (accordionItem) {
                        accordionItem.querySelector('.accordion__content')?.classList.add("open");
                    }
                }
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *

    function externalLinks() {
        for (let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];

            // check if link has same hostname. if not add target blank.
            currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
        }
    };

    externalLinks();




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native parallax replacement
    // *
    // *

    const initParallax = () => {
        const parallaxImages = document.querySelectorAll('.js-parallax');
        if (parallaxImages.length === 0) return;

        const observerOptions = {
            threshold: 0,
            rootMargin: "0px"
        };

        const parallaxObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.dataset.visible = "true";
                } else {
                    entry.target.dataset.visible = "false";
                }
            });
        }, observerOptions);

        parallaxImages.forEach(img => {
            parallaxObserver.observe(img);
            // set initial scale to have some buffer for moving
            img.style.transform = "scale(1.2) translateY(0px)";
        });

        const updateParallax = () => {
            parallaxImages.forEach(img => {
                if (img.dataset.visible === "true") {
                    const rect = img.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const elementHeight = rect.height;
                    const elementCenter = rect.top + elementHeight / 2;
                    const viewportCenter = windowHeight / 2;

                    // calculate distance from center of viewport (-1 to 1)
                    const distance = (elementCenter - viewportCenter) / (windowHeight / 2 + elementHeight / 2);
                    const movement = distance * 50; // shift by 50px max

                    img.style.transform = `scale(1.2) translateY(${movement}px)`;
                }
            });
            requestAnimationFrame(updateParallax);
        };

        requestAnimationFrame(updateParallax);
    };

    initParallax();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native aos replacement (Intersection Observer)
    // *
    // *

    const aosElements = document.querySelectorAll('[data-aos]');

    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const aosObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('aos-animate');
                if (entry.target.getAttribute('data-aos-once') !== 'false') {
                    observer.unobserve(entry.target);
                }
            } else {
                if (entry.target.getAttribute('data-aos-once') === 'false') {
                    entry.target.classList.remove('aos-animate');
                }
            }
        });
    }, observerOptions);

    aosElements.forEach(element => {
        const delay = element.getAttribute('data-aos-delay');
        if (delay) {
            element.style.transitionDelay = `${delay}ms`;
        }
        aosObserver.observe(element);
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * menu toggle
    // *
    // *

    const menuTriggers = document.querySelectorAll('.js-menu-trigger');
    const menuCloses = document.querySelectorAll('.js-menu-close');
    const overlayMenu = document.querySelector('.menu');

    // Focusable elements inside the menu
    const focusableSelectors = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let lastTrigger = null;

    const openMenu = (trigger) => {
        lastTrigger = trigger || null;
        overlayMenu.classList.add('is-visible');
        overlayMenu.removeAttribute('inert');
        document.body.classList.add('no-scroll');
        // Move focus to close button
        const closeBtn = overlayMenu.querySelector('.js-menu-close');
        if (closeBtn) closeBtn.focus();
    };

    const closeMenu = () => {
        overlayMenu.classList.remove('is-visible');
        overlayMenu.setAttribute('inert', '');
        document.body.classList.remove('no-scroll');
        // Return focus to the trigger that opened the menu
        if (lastTrigger) lastTrigger.focus();
    };

    if (overlayMenu) {
        // Open / Toggle
        menuTriggers.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                if (overlayMenu.classList.contains('is-visible')) {
                    closeMenu();
                } else {
                    openMenu(btn);
                }
            });
        });

        // Close button
        menuCloses.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                closeMenu();
            });
        });

        // Close on click outside (background)
        overlayMenu.addEventListener('click', (e) => {
            if (e.target === overlayMenu) closeMenu();
        });

        // Focus trap + ESC
        document.addEventListener('keydown', (e) => {
            if (!overlayMenu.classList.contains('is-visible')) return;

            if (e.key === 'Escape') {
                closeMenu();
                return;
            }

            if (e.key === 'Tab') {
                const focusable = Array.from(overlayMenu.querySelectorAll(focusableSelectors));
                if (!focusable.length) return;

                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                if (e.shiftKey) {
                    // Shift+Tab: vom ersten Element → zurück zum letzten
                    if (document.activeElement === first) {
                        e.preventDefault();
                        last.focus();
                    }
                } else {
                    // Tab: vom letzten Element → zurück zum ersten
                    if (document.activeElement === last) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * menu submenu toggle
    // *
    // *
    // *

    const submenuToggles = document.querySelectorAll('.js-submenu-toggle');

    if (submenuToggles) {
        submenuToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                toggle.classList.toggle('active');

                // Toggle aria-expanded
                const expanded = toggle.getAttribute('aria-expanded') === 'true' || false;
                toggle.setAttribute('aria-expanded', !expanded);

                // Find sibling submenu
                // Structure: .menu__header > toggle -> sibling of header is submenu
                const parentHeader = toggle.closest('.menu__header');
                if (parentHeader) {
                    const submenu = parentHeader.nextElementSibling;
                    if (submenu && submenu.classList.contains('menu__submenu')) {
                        submenu.classList.toggle('open');
                    }
                }
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header on scroll
    // *
    // *
    // *

    const header = document.querySelector('.header');

    if (header) {
        const headerScroll = () => {
            if (window.scrollY > 50) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        };

        window.addEventListener('scroll', headerScroll);
        window.addEventListener('load', headerScroll);
    }
});
